'use strict'

exports.url = () =>{
    //return 'http://localhost:3143/api/jFX_Ms8/zNH-Mgs';
    return 'https://pcvirgo.com/api/jFX_Ms8/zNH-Mgs';
}